import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-library-timings',
  templateUrl: './library-timings.component.html',
  styleUrls: ['./library-timings.component.scss']
})
export class LibraryTimingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
